<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control field-area-row">
      <el-select v-model="region" placeholder="請選擇大區" clearable class="area-select" @change="onRegionChange">
        <el-option v-for="o in regionList" :key="o" :label="o" :value="o" />
      </el-select>
      <el-select v-model="central" placeholder="請選擇中區" clearable class="area-select" :disabled="!region" @change="onCentralChange">
        <el-option v-for="o in centralList" :key="o" :label="o" :value="o" />
      </el-select>
      <el-select v-model="xq" placeholder="請選擇小區" clearable class="area-select" :disabled="!central" @change="emitValue">
        <el-option v-for="o in xqList" :key="o" :label="o" :value="o" />
      </el-select>
    </div>
  </div>
</template>

<script>
import { getActivitySq } from '@/api/activity'

export default {
  name: 'FieldArea',
  props: { field: Object, value: { default: () => ({}) } },
  data () {
    return {
      region: '', central: '', xq: '',
      regionList: [], centralList: [], xqList: []
    }
  },
  created () { this.fetchArea(1, '') },
  methods: {
    async fetchArea (level, area) {
      try {
        const res = await getActivitySq(level, area)
        if (res.code !== 200) return
        const raw = res.data || []
        const list = Array.isArray(raw) ? raw : Object.values(raw)
        if (level === 1) this.regionList = list
        if (level === 2) this.centralList = list
        if (level === 3) this.xqList = list
      } catch (e) { /* 靜默處理 */ }
    },
    onRegionChange (val) {
      this.central = ''; this.xq = ''
      this.centralList = []; this.xqList = []
      if (val) this.fetchArea(2, val)
      this.emitValue()
    },
    onCentralChange (val) {
      this.xq = ''; this.xqList = []
      if (val) this.fetchArea(3, val)
      this.emitValue()
    },
    emitValue () {
      this.$emit('input', {
        region_name: this.region || '',
        region_code: this.region || '',
        central_district_name: this.central || '',
        central_district_code: this.central || '',
        xq_name: this.xq || '',
        xq_number: this.xq || ''
      })
    },
    reset () {
      this.region = ''; this.central = ''; this.xq = ''
      this.centralList = []; this.xqList = []
      this.fetchArea(1, '')
    }
  }
}
</script>

<style scoped>
.field-area-row { display: flex; gap: 8px; }
.area-select { flex: 1; min-width: 0; }
@media screen and (max-width: 768px) {
  .field-area-row { flex-direction: column; }
  .area-select { width: 100%; }
}
</style>
